import { Button, Col, Form, Row } from "react-bootstrap";
import * as React from 'react';
export default {
  Button,
  Col,
  Form,
  Row,
  React
};